import { render, staticRenderFns } from "./vipCourt.vue?vue&type=template&id=a40498ba&"
import script from "./vipCourt.vue?vue&type=script&lang=js&"
export * from "./vipCourt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports